const routes = [
  {
    path: "/:country(tz|ke|gh)?",
    name: "landing",
    component: () => import("@/pages/LandingPage.vue"),
    onlyGuests: true,
  },
  {
    path: "/auth",
    name: "auth",
    component: () => import("@/pages/AuthPage.vue"),
    onlyGuests: true,
    public: false,
  },
  {
    path: "/auth/signup",
    name: "auth.signup",
    component: () => import("@/pages/SignUpPage.vue"),
    onlyGuests: true,
    public: false,
  },
  {
    path: "/auth/login",
    name: "auth.login",
    component: () => import("@/pages/LoginPage.vue"),
    onlyGuests: true,
    public: false,
  },
  {
    path: "/support",
    name: "support",
    component: () => import("@/pages/SupportPage.vue"),
  },
  {
    path: "/terms",
    name: "terms",
    component: () => import("@/pages/TermsOfServicePage.vue"),
  },
  {
    path: "/privacy",
    name: "privacy",
    component: () => import("@/pages/PrivacyPolicyPage.vue"),
  },
  {
    path: "/CSA",
    name: "csa",
    component: () => import("@/pages/CSAEPolicy.vue"),
  },
  {
    path: "/i",
    name: "interview-short",
    component: () => import("@/pages/PublicSurveyPage.vue"),
  },
  {
    path: "/interview",
    name: "interview",
    component: () => import("@/pages/PublicSurveyPage.vue"),
  },
];

export default routes.map((route) => {
  const meta = {
    public: route.public ?? true,
    onlyGuests: route.onlyGuests,
  };
  return { ...route, meta };
});
